import { render, staticRenderFns } from "./o-site-header-v2.vue?vue&type=template&id=fdc268f6&scoped=true"
import script from "./o-site-header-v2.vue?vue&type=script&lang=js"
export * from "./o-site-header-v2.vue?vue&type=script&lang=js"
import style0 from "./o-site-header-v2.vue?vue&type=style&index=0&id=fdc268f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc268f6",
  null
  
)

export default component.exports